import { render } from "./PartyScatter.vue?vue&type=template&id=1fde6c12"
import script from "./PartyScatter.vue?vue&type=script&lang=js"
export * from "./PartyScatter.vue?vue&type=script&lang=js"

import "./PartyScatter.vue?vue&type=style&index=0&id=1fde6c12&lang=scss"

import exportComponent from "/Users/kakkote/Mediadeski/2022-01-aluevaalit-kompassianalyysi/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__